import { useTheme } from '@mui/material';

const toolbarHeight: string = '34px';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    actionBar: {
      '&': {
        minHeight: toolbarHeight,
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
      },
      backgroundColor: theme.palette.background.paper,
      padding: 0,
      minHeight: toolbarHeight,
      height: toolbarHeight,
      zIndex: 1,
      width: '100%',
      position: 'fixed',
    },
    flexContainer: {
      justifyContent: 'space-between',
    },
    tabs: {
      minHeight: toolbarHeight,
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1),
      maxHeight: toolbarHeight,
    },
    tab: {
      minWidth: 'auto',
      padding: 0,
      paddingRight: theme.spacing(0.5),
      paddingLeft: theme.spacing(0.5),
      minHeight: toolbarHeight,
      maxHeight: toolbarHeight,
    },
  };
};
